import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function UnitMaster(props) {
  const [units, setUnits] = useState([]);
  const [unitId, setUnitId] = useState('');
  const [unitName, setUnitName] = useState('');
  const [deptCode, setDeptCode] = useState('');
  const [yearCode, setYearCode] = useState('');
  const [userId, setUserId] = useState('');
 
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editUnitId, setEditUnitId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [unitMasterEntries, setUnitMasterEntries] = useState([]);

  useEffect(() => {
    fetchUnitMaster();
  }, []);

  const fetchUnitMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/units');
      setUnitMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setUnitId (nextEntryNo);
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  
    const calculateMaxEntryNo = (entries) => {
          let maxEntryNo = 0;
          for (const entry of entries) {
          if (entry.UnitId > maxEntryNo) {
          maxEntryNo = entry.UnitId;
          }
          }
          return maxEntryNo;
    };

  const addUnit = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/units', {
        UnitId: unitId,
        UnitName: unitName,
        DeptCode: deptCode,
        YearCode: yearCode,
        USERID: props.name
      });
      fetchUnitMaster();
      setUnitId('');
      setUnitName('');
      setDeptCode('');
      setYearCode('');
      setUserId('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateUnit = async (UnitId) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/units/${UnitId}`, {
        UnitId: unitId,
        UnitName: unitName,
        DeptCode: deptCode,
        YearCode: yearCode,
        USERID: props.name
      });
      fetchUnitMaster();
      setUnitId('');
      setUnitName('');
      setDeptCode('');
      setYearCode('');
      setUserId('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteUnit = async (UnitId) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/units/${UnitId}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchUnitMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (unit) => {
    setFormMode('edit');
    setUnitId(unit.UnitId);
    setUnitName(unit.UnitName);
    setDeptCode(unit.DeptCode);
    setYearCode(unit.YearCode);
    setUserId(unit.UserID);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = units.filter((unit) => {
      const UnitId = unit.UnitId.toString().toLowerCase();
      const UnitName = unit.UnitName.toString().toLowerCase();
      const DeptCode = unit.DeptCode.toString().toLowerCase();
      const YearCode = unit.YearCode.toString().toLowerCase();
      const UserID = unit.UserID.toString().toLowerCase();

      return (
        UnitId.includes(searchQuery.toLowerCase()) ||
        UnitName.includes(searchQuery.toLowerCase()) ||
        DeptCode.includes(searchQuery.toLowerCase()) ||
        YearCode.includes(searchQuery.toLowerCase()) ||
        UserID.includes(searchQuery.toLowerCase())
      );
    });

    setUnitMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, units]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setUnits(units);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditUnitId('');
    setUnitId('');
    setUnitName('');
    setDeptCode('');
    setYearCode('');
    setUserId('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "UnitData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>UnitMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>
          {formMode === 'add' ? 'Add' : 'Edit'}
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="UnitId" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              UnitId
            </label>
            <input
              type="text"
              value={unitId}
              readOnly
              placeholder="UnitId"
              style={{ marginBottom: '5px', padding: '5px', width: '80%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="UnitName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              UnitName
            </label>
            <input
              type="text"
              value={unitName}
              onChange={(e) => setUnitName(e.target.value)}
              placeholder="UnitName"
              style={{ marginBottom: '5px', padding: '5px', width: '80%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="DeptCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              DeptCode
            </label>
            <input
              type="text"
              value={deptCode}
              onChange={(e) => setDeptCode(e.target.value)}
              placeholder="DeptCode"
              style={{ marginBottom: '5px', padding: '5px', width: '80%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="YearCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              YearCode
            </label>
            <input
              type="text"
              value={yearCode}
              onChange={(e) => setYearCode(e.target.value)}
              placeholder="YearCode"
              style={{ marginBottom: '5px', padding: '5px', width: '80%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addUnit : () => updateUnit(unitId)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  UnitId
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  UnitName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  DeptCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  YearCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {unitMasterEntries.map((unit) => (
                <tr key={unit.UnitId} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{unit.UnitId}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{unit.UnitName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{unit.DeptCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{unit.YearCode}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(unit)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteUnit(unit.UnitId)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default UnitMaster;
